import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createForm() {
  return new FormGroup({
    countries: new FormControl<string[]>([], { nonNullable: true, validators: [Validators.required, Validators.minLength(1)] }),
    budget: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    skill: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    lastNameKana: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    firstNameKana: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    phoneNumber: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    email: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    agree: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] })
  });
}
